import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from "antd";
const TONE_COLORS = {
    primary: (token)=>[
            token.colorPrimary,
            token.colorPrimaryBg
        ],
    success: (token)=>[
            token.colorSuccess,
            token.colorSuccessBg
        ],
    warning: (token)=>[
            token.colorWarning,
            token.colorWarningBg
        ]
};
// Centered status card shared by the affiliate pending / error / success states:
// a circular tinted icon badge over a heading, body copy and an optional action.
const AffiliateStatePanel = ({ tone, icon, heading, action, children })=>{
    const { token } = theme.useToken();
    const [iconColor, badgeBackground] = TONE_COLORS[tone](token);
    return /*#__PURE__*/ _jsx("div", {
        className: "rc-account-v2-affiliate-state",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "rc-account-v2-affiliate-state__card",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-affiliate-state__badge",
                    style: {
                        color: iconColor,
                        background: badgeBackground
                    },
                    children: icon
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-affiliate-state__heading",
                    style: {
                        color: token.colorTextHeading
                    },
                    children: heading
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-affiliate-state__body",
                    style: {
                        color: token.colorTextSecondary
                    },
                    children: children
                }),
                action && /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-affiliate-state__action",
                    children: action
                })
            ]
        })
    });
};
export { AffiliateStatePanel };
